/* eslint-disable no-param-reassign,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars */

xplenty.directive('packageForm', [
  '$location',
  '$rootScope',
  '$timeout',

  function ($location, $rootScope, $timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../../views/directives/forms/package-form.html'),

      replace: true,

      scope: {
        package: '=ngModel',
      },

      controller: [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        'modalService',
        'Package',

        function ($scope, $state, $rootScope, $stateParams, modalService, Package) {
          let packageTemplates = [];

          $scope.flowTypeOptions = [
            {
              value: 'dataflow',
              text: 'package.form.new.labels.dataflow',
              translate: true,
            },
            {
              value: 'workflow',
              text: 'package.form.new.labels.workflow',
              translate: true,
            },
          ];

          function filterTemplates(flowType) {
            $scope.packageTemplateOptions = packageTemplates.filter(
              ({ flow_type, value }) => flow_type === flowType || value === 'blank',
            );
          }

          $scope.onFlowTypeChange = (flowType) => {
            $scope.package.flow_type = flowType;
            filterTemplates(flowType);
          };

          $scope.onTemplateIdChange = (templateId) => {
            $scope.package.package_template_id = templateId;
          };

          $scope.$watch('package.flow_type', function () {
            $scope.package.package_template_id = 'blank';
          });

          Package.templates().subscribe(function (resPackageTemplates) {
            packageTemplates = [
              { value: 'blank', text: 'package.form.new.labels.blank_template', translate: true },
              ...resPackageTemplates.map(({ id, name, flow_type }) => ({ value: id, text: name, flow_type })),
            ];
            filterTemplates($scope.package.flow_type);
          });

          $scope.createPackage = function () {
            return $rootScope.createPackage(
              $scope.package,
              function (newPackage) {
                modalService.hideModal();
                $state.go('app.account.packages.item.edit', newPackage);
              },
              function (res) {
                // TODO: add error handler
              },
            );
          };
        },
      ],
    };
  },
]);
